import { useEffect, useRef, useState } from 'react';

// Progress-based loading hook that completes smoothly over targetMs
const useLoadingProgress = (targetMs = 1200) => {
  const [progress, setProgress] = useState(0); // 0 → 1
  const [loading, setLoading] = useState(true);
  const rafRef = useRef(null);

  useEffect(() => {
    const start = performance.now();

    const tick = (now) => {
      const elapsed = now - start;
      const pct = Math.min(elapsed / targetMs, 1);
      // Ease-out cubic for smooth finish
      const eased = 1 - Math.pow(1 - pct, 3);
      setProgress(eased);

      if (pct < 1) {
        rafRef.current = requestAnimationFrame(tick);
      } else {
        setLoading(false);
      }
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [targetMs]);

  return { progress, loading };
};

export default useLoadingProgress;


